import { render, staticRenderFns } from "./saucer_bottom.vue?vue&type=template&id=2720f7c8"
import script from "./saucer_bottom.vue?vue&type=script&lang=js"
export * from "./saucer_bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports